import {
  IAccessMenuInput,
  IGlobalSetting,
  IPriceRate,
  OLogExperiment,
} from "@types";
import gate from "../gate";

import client from "../http-clients/api";

const commonApi = {
  getAccessMenu: () =>
    gate.get<IAccessMenuInput, never, never>({
      client,
      url: `/access/menu`,
    }),

  submitLog: (data: OLogExperiment) =>
    gate.post<{ message: string; status: boolean }, OLogExperiment, never>({
      client,
      url: `/experiment`,
      data: data,
    }),
  ratePrice: () =>
    gate.get<IPriceRate, never, never>({
      client,
      url: `/rates`,
    }),
  getGlobalSetting: () =>
    gate.get<IGlobalSetting, never, never>({
      client,
      url: `/settings/global/captcha`,
    }),
};

export default commonApi;
